import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type LoginModalProps = InheritableModalProps & {
  onAction: () => void
}

export const LogoutModal = ({ onAction, ...props }: LoginModalProps) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={['fal', 'question-circle']} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {t({ id: 'logout.title', message: 'Afmelden' })}
        </H3>

        <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
          {t({
            id: 'logout.body1',
            message: 'Ben je zeker dat je je wil afmelden?',
          })}
          <br />
          {t({
            id: 'logout.body2',
            message:
              'Na het afmelden vraagt eHealth je om ook daar af te melden. Bevestig dit om je persoonlijke gegevens te beschermen.',
          })}
        </P>

        <Button variant='Primary' onClick={onAction}>
          {t({
            id: 'logout.confirm',
            message: 'Nu afmelden',
          })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose}>
          {t({
            id: 'logout.cancel',
            message: 'Annuleren',
          })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}
